import React from "react";
import "../NagthaneComponent/NagthaneCss/MissionSection.css";

export default function MissionSection() {
  return (
    <section className="mission-container">
      <h2 className="mission-title">आमचे ध्येय</h2>

      <h3 className="mission-subtitle">
       आमचे ध्येय म्हणजे “सर्वांसाठी विकास आणि स्वच्छ, सुशिक्षित, आत्मनिर्भर नगठाणे” 
      </h3>

      <p className="mission-text">
      घडविणे. ग्रामपंचायत, स्थानिक नागरिक आणि शासन योजनांच्या सहकार्याने आम्ही गावातील मूलभूत सुविधा उभारण्यावर भर देतो – जसे की रस्ते, पाणीपुरवठा, आरोग्यसेवा, स्वच्छता आणि डिजिटल सेवांचा विस्तार.
      </p>
    </section>
  );
}
